var exports = {
  "k": "xfd349460--611a70--container",
  "Y": "xfd349460--611a70--basic-info",
};

module.exports = exports;
